const otpVerificationCodeEntryTemplate = `
<pwr-otp-identity-verification-code-entry-component 
    options="ctrl.options" 
    noCodeFunction="openOTPNoCodeModal"
    is-ots-user="isOtsUser"
></pwr-otp-identity-verification-code-entry-component>
`;
export default otpVerificationCodeEntryTemplate;
